import PropTypes from "prop-types";
import React from "react";
import { initialize, propTypes } from "redux-form";
import reduxFormSubmitter from "app/utils/form/reduxFormSubmitter";
import { bindActionCreators } from "redux";
import { fetchPrepackageAccommodationsOfDuration } from "app/pages/PrePackage/actions/prePackageOfferActionCreators";
import { clearQuotation } from "app/pages/Booking/Quotation/quotationActionCreators";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import { clearBooking, updateBooking } from "app/pages/Booking/bookingActionCreators";
import { fields, validate } from "app/pages/PrePackage/rental/rentalSearchEngineSchema";
import RentalSearchEngine from "app/pages/PrePackage/rental/RentalSearchEngine.jsx";
import { withRouter } from "react-router-dom";
import { bookingPropTypes } from "app/utils/propTypes";
import {
	getAllAvailableDurations,
	getDurations,
	getMonths,
	getPrices,
	getQuotationPayload,
	getRentalAccommodations,
	selectBookingDataToHydrate,
} from "app/pages/PrePackage/containers/searchEngineSelectors.js";
import { withAlert } from "app/pages/.shared/Alert/AlertContainer.jsx";
import { injectIntl } from "react-intl";
import { OFFER_CONTRACT_TYPES, OFFER_TYPES } from "app/constants";
import { pushTagOnSearchEngineSubmit } from "app/utils/analytics";
import get from "lodash/get";
import {
	finishLoadingBar,
	showLoadingBar,
} from "app/pages/.shared/LoadingBar/loadingBarActionCreators";
import Button from "app/pages/.shared/form/Button";
import { parseQueries } from "app/utils/routerUtils";
import isEqual from "lodash/isEqual";
import { isProductExpired } from "app/pages/FicheProduit/ficheProduitSelector";

class RentalSearchEngineContainer extends React.Component {
	constructor() {
		super();
		this.routerWillLeave = this.routerWillLeave.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		// Si le produit a changé, il faut réinitialiser ses choix dans le moteur de recherche sinon
		// il voit les prix d'un précédent produit
		if (nextProps.productId !== this.props.productId) {
			nextProps.clearBooking();
		}

		// Faire en sorte que l'appel de fetchPrepackageAccommodationsOfDuration se passe après celui de fetchProduit
		if (!isEqual(this.props.prePackageOffer, nextProps.prePackageOffer)) {
			// On passe les nextProps ici pour s'assurer que c'est bien la dernière version des props
			// contenant les prePackages car sinon ca ne fonctionne pas dans /booking/search
			nextProps.fetchPrepackageAccommodationsOfDuration(
				nextProps.uriToFetchForAO,
				nextProps.booking.duration.value,
				nextProps.booking.offer.type,
				nextProps.booking.offer.contractType
			);
		}
	}

	componentDidMount() {
		const {
			initializeForm,
			formInitialValues,
			history,
			updateBooking,
			productUri,
			match = {},
			location = {},
			clearBooking,
		} = this.props;

		const query = parseQueries(location.search);

		const productUriFromPath = match.params.productUri; // fiche produit /:productUri
		const productUriFromQuery = query.productUri; // /booking/search /booking/search?productUri=my-product

		const hasProductChanged =
			(productUriFromPath && productUriFromPath !== productUri) ||
			(productUriFromQuery && productUriFromQuery !== productUri);

		if (hasProductChanged) {
			clearBooking();
		}

		// J'ai du dispather manuellement l'initialisation du formulaire
		// car à cause du server side rendering, le form est à l'état _initialised = true
		// ce qui empêche l'initialisation normal via initiialValues
		initializeForm(formInitialValues);

		history.block(this.routerWillLeave);

		// permet d'avoir les prix lorsque l'on persiste le choix du moteur de recherche
		this.props.fetchPrepackageAccommodationsOfDuration(
			this.props.uriToFetchForAO,
			this.props.booking.duration.value,
			this.props.booking.offer.type,
			this.props.booking.offer.contractType
		);

		updateBooking({
			offer: {
				type: OFFER_TYPES.ACCOMODATION_ONLY,
				contractType: OFFER_CONTRACT_TYPES.RENTAL,
			},
		});
	}

	componentWillUnmount() {
		this.props.finishLoadingBar();
		this.props.acceptCookyPolicy();
	}

	routerWillLeave(nextLocation) {
		// return false to prevent a transition w/o prompting the user,
		// or return a string to allow the user to decide:
		this.props.acceptCookyPolicy();

		const isLeavingToQuotePageWithDirtyForm =
			this.props.dirty &&
			nextLocation.action === "POP" &&
			nextLocation.pathname === "/booking/quote";

		if (isLeavingToQuotePageWithDirtyForm) {
			const alertTitle = this.props.intl.formatMessage({
				id: `alert.booking.data.changes.confirmation.title`,
			});
			const alertMessage = this.props.intl.formatMessage(
				{ id: `alert.booking.data.changes.confirmation.message` },
				{ buttonLabel: "Continuer" }
			);
			const alertActionNodes = [
				<Button design="primary" key={"alert.booking.data.changes.confirmation.label"}>
					{this.props.intl.formatMessage({
						id: `alert.booking.data.changes.confirmation.label`,
					})}
				</Button>,
			];
			this.props.showAlert({ alertTitle, alertMessage, alertActionNodes });
			return false;
		}

		return true;
	}

	render() {
		let { prePackageOffer, updateBooking, booking, ...rest } = this.props;

		return (
			<RentalSearchEngine
				updateBooking={updateBooking}
				prePackageOffer={prePackageOffer}
				booking={booking}
				{...rest}
			/>
		);
	}
}

RentalSearchEngineContainer.propTypes = {
	...propTypes,
	intl: PropTypes.object,
	history: PropTypes.shape({ push: PropTypes.func, replace: PropTypes.func }),
	route: PropTypes.object,
	finishLoadingBar: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	fetchPrepackageAccommodationsOfDuration: PropTypes.func,
	prePackageOffer: PropTypes.object,
	productId: PropTypes.string,
	mealBasis: PropTypes.string,
	booking: bookingPropTypes,
	updateBooking: PropTypes.func,
	initializeForm: PropTypes.func,
	showAlert: PropTypes.func,
	formInitialValues: PropTypes.object,
};

const beforeValidateForm = () => {
	pushTagOnSearchEngineSubmit();
};

const beforeSubmit = (values, ownsProps, dispatch) => {
	dispatch(showLoadingBar());
};

const onSubmitSuccess = (ownProps, dispatch) => {
	dispatch(clearQuotation());
	ownProps.history.push({
		pathname: "/booking/quote",
	});
};

const mapStateToProps = (state, ownProps) => {
	const quotationPayload = getQuotationPayload(
		ownProps.match.params.productUri || state.ficheProduit.uri
	)(state);
	const currentBooking = state.booking;

	const selectedQuotationPayloadData = selectBookingDataToHydrate(
		ownProps.match.params.productUri || state.ficheProduit.uri
	)(state);

	const lastBooking = {
		...currentBooking,
		...selectedQuotationPayloadData,
	};

	const durations = getDurations(state.booking.offer.type || get(quotationPayload, "offer.type"))(
		state
	);
	const rentalAccommodations = getRentalAccommodations(
		state.booking.offer.type || get(quotationPayload, "offer.type")
	)(state);

	// TODO Refacto selector avec arguments
	const pricesPerMonth = getPrices(
		state.booking.offer.type || get(quotationPayload, "offer.type"),
		state.booking.offer.contractType || get(quotationPayload, "offer.contractType")
	)(state);

	// TODO Refacto selector avec arguments
	const months = getMonths(
		state.booking.offer.type || get(quotationPayload, "offer.type"),
		state.booking.offer.contractType || get(quotationPayload, "offer.contractType")
	)(state);

	const formInitialValues = {
		departureDate: lastBooking.departureDate,
		duration: lastBooking.duration.value,
		rentalAccommodation: lastBooking.rentalAccommodation.accommodation,
	};

	const prepackageOfferForAO = state.prePackageOffer.offers.find(
		offer => get(offer, "pricing.type") === OFFER_TYPES.ACCOMODATION_ONLY
	);

	return {
		uriToFetchForAO: get(prepackageOfferForAO, "pricing.uri"),
		allAvailableDurations: getAllAvailableDurations(state),
		prePackageOffer: state.prePackageOffer,
		productId: state.ficheProduit.id,
		productUri: state.ficheProduit.uri,
		mealBasis: state.ficheProduit.fromPriceType.mealBasis,
		strategy: state.partner.strategy,
		booking: state.booking,
		prices: pricesPerMonth,
		rentalAccommodations,
		durations,
		months,
		formInitialValues,
		uuid: state.auth.uuid,
		shop: state.shop,
		isDealExpired: isProductExpired(state),
	};
};

const mapDispatchToProps = dispatch => {
	return Object.assign(
		{},
		{
			initializeForm: initializeValues => {
				dispatch(initialize("booking-search-form", initializeValues));
			},
		},
		bindActionCreators(
			{
				updateBooking,
				clearBooking,
				finishLoadingBar,
				acceptCookyPolicy,
				fetchPrepackageAccommodationsOfDuration,
				// hydrateQuotationPayload,
			},
			dispatch
		)
	);
};

const reduxFormSubmitterConfig = {
	form: "booking-search-form",
	fields,
	beforeValidateForm,
	validateForm: validate,
	beforeSubmit,
	onSubmitSuccess,
};

export default injectIntl(
	withRouter(
		reduxFormSubmitter(reduxFormSubmitterConfig, mapStateToProps, mapDispatchToProps)(
			withAlert(RentalSearchEngineContainer)
		)
	)
);
